// SPDX-License-Identifier: AGPL-3.0-or-later

// LOCAL-ONLY: the message menu's "Relocate messages" entry (right-click menu and the phone-width long-press sheet),
// which starts relocation with that message as the start, as Obyrus does from its message sheet. Same rule as
// Obyrus' canStartRelocationSelection: a sent user message in a server text or announcement channel, a DM or a group
// DM; not threads, forums or media channels (relocation refuses them) and not system messages. Exclude from upstream
// sync.

import {RelocationStrings} from '@app/features/channel/state/RelocationStrings';
import SelectMode from '@app/features/channel/state/SelectMode';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {ChannelTypes} from '@fluxer/constants/src/ChannelConstants';

export const RELOCATE_MESSAGE_MENU_ITEM_ID = 'message_relocate';

const RELOCATION_SOURCE_TYPES = new Set<number>([
	ChannelTypes.GUILD_TEXT,
	ChannelTypes.GUILD_ANNOUNCEMENT,
	ChannelTypes.DM,
	ChannelTypes.GROUP_DM,
]);

export interface RelocateMenuEntry {
	id: typeof RELOCATE_MESSAGE_MENU_ITEM_ID;
	label: string;
	onClick: () => void;
}

export function relocateMenuEntry(params: {
	isSent: boolean;
	isUserMessage: boolean;
	interactive: boolean;
	channelType: number | null | undefined;
	channelId: string;
	messageId: string;
	onClose?: () => void;
}): RelocateMenuEntry | null {
	if (!params.isSent || !params.isUserMessage || !params.interactive) return null;
	if (params.channelType == null || !RELOCATION_SOURCE_TYPES.has(params.channelType)) return null;
	return {
		id: RELOCATE_MESSAGE_MENU_ITEM_ID,
		label: RelocationStrings.relocateMessages,
		onClick: () => {
			const start = () => SelectMode.startFrom(params.channelId, params.messageId);
			// The phone-width sheet closes through a history entry, and so does the relocate panel: start only after
			// the sheet's entry is gone, or its "back" would close the panel at once.
			if (params.onClose) ModalCommands.runAfterBottomSheetClose(params.onClose, start);
			else start();
		},
	};
}
